import React from 'react';
import { useFirmwareUpdateStore } from './FirmwareUpdate/state/use-firmware-update-store';
import DeviceWarningAlert from './DeviceWarningAlert';
import PaymentModal from '../../Payments/PaymentModal';
import { usePaymentsStore } from '../../Payments/state/use-payments-store';
import FirmwareUpdateModal from './FirmwareUpdate/FirmwareUpdateModal';

const ControllerAlerts = ({ device }) => {
  const openPaymentModal = usePaymentsStore((state) => state.openPaymentModal);
  const openFirmwareModal = useFirmwareUpdateStore((state) => state.open);

  return (
    <div className="flex items-center gap-1 ml-auto shrink-0">
      {device?.payment_required && (
        <DeviceWarningAlert
          tooltipText={'Устройство заблокировано:\nтребуется оплата NB‑IoT пакета'}
          colorClass="text-red-500"
          ariaLabel="Открыть оплату NB-IoT пакета"
          onOpen={openPaymentModal}>
          <PaymentModal />
        </DeviceWarningAlert>
      )}
      {Boolean(device?.update_required) && (
        <DeviceWarningAlert
          tooltipText={'Доступно обновление устройства:\nНастройте разрешение на обновление'}
          colorClass="text-orange-500"
          ariaLabel="Управление обновлением устройства"
          onOpen={() => openFirmwareModal(device)}>
          <FirmwareUpdateModal />
        </DeviceWarningAlert>
      )}
    </div>
  );
};

export default ControllerAlerts;
